// 去除undefined值
const washData = function (values) {
	let _formData = {};
	for (var key in values) {
		let _value = values[key];
		if (_value) {
			if (Array.isArray(_value)) {
				_value = _value.join(',');
			}
			_formData[key] = _value;
		}
	}
	return _formData;
};

//清除所有cookie函数
const clearAllCookie = function () {
	let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
	if (keys) {
		for (var i = keys.length; i--;)
			document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
	}
};


export {washData, clearAllCookie};